import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import resolveUrl from '../../../utils/urls/resolve-url';
import * as b from "../../bootstrap.module.css";
import Icon from "../../icon.tsx";

const PaydayLoanContents = () => {
  const { ranking, articles } = useStaticQuery(graphql`
    query PaydayLoanContents {
      ranking: mysqlRanking(mysqlId: {eq: 2}) {
        name
        url
        prefix_url
      }

      articles: allMysqlBlog(
        filter: {blogTerms: {elemMatch: {term: {eq: "menu-chwilowki"}}}},
        limit: 6
      ) {
        nodes {
          title
          terms_path
          term_normalized
          url
          thumbnail_canvas
        }
      }
    }
  `);

  return (<>
    {ranking && (<>
      <strong>Rankingi</strong>

      <Link 
        to={resolveUrl(ranking.prefix_url, ranking.url)} 
        className={["top-navigation-link", b.mt2, b.mb4].join(' ')}
      >
        <span className="top-navigation-link-icon">
          <Icon icon="Ranking" size={34} />
        </span>
        {ranking.name.split('-')[0]}
      </Link>
    </>)}

    {articles.nodes.length > 0 && (<>
      <strong>Artykuły o chwilówkach</strong>

      <div className={['top-navigation-posts', b.mt2, b.pt1].join(' ')}>
        {articles.nodes.map((article, i) => (
          <Link key={i} to={resolveUrl(article.terms_path, article.term_normalized, article.url)}>
            <img src={article.thumbnail_canvas?.replace('/op/', '/of/')} className="top-navigation-thumbnail" loading="lazy" alt="" />
            
            <strong>{article.title}</strong>
          </Link>
        ))}
      </div>  
    </>)} 
  </>);
};

export default PaydayLoanContents;
